<div class="flex min-w-0 flex-auto flex-col items-center sm:justify-center -m-6">
    <div class="w-full px-4 py-8 sm:bg-card sm:w-auto sm:rounded-2xl sm:p-12 sm:shadow">
        <div class="mx-auto w-full max-w-80 sm:mx-0 sm:w-80">
            <!-- Title -->
            <div class="text-center text-3xl font-extrabold text-gray-800 flex items-center justify-center gap-2">
                Still There?
            </div>

            <div class="font-medium line-clamp-2 mt-0.5 text-center text-secondary text-md">
                <p>
                    We paused your session due to inactivity. Please enter your password to resume.
                </p>
            </div>


            <!-- Re-authentication form -->
            <form class="mt-8" [formGroup]="reAuthForm" #reAuthNgForm="ngForm">
                <!-- Password field only -->
                <mat-form-field class="w-full">
                    <mat-label>Password</mat-label>
                    <input id="password" matInput type="password" [formControlName]="'password'" #passwordField />
                    <button mat-icon-button type="button" (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        " matSuffix>
                        @if (passwordField.type === 'password') {
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                        }
                        @if (passwordField.type === 'text') {
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
                        }
                    </button>
                    <mat-error> Password is required </mat-error>
                </mat-form-field>

                <!-- Submit button -->
                <button class="fuse-mat-button-large mt-6 w-full" mat-flat-button [color]="'primary'"
                    [disabled]="reAuthForm.disabled" (click)="reAuthenticate()">
                    @if (!reAuthForm.disabled) {
                    <span>Re-authenticate</span>
                    }
                    @if (reAuthForm.disabled) {
                    <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
                    }
                </button>
            </form>
        </div>
    </div>
</div>